<template>
    <div>
        <!-- Modal -->
        <div class="modal fade" :id="'amostraModal' + nome_base" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            Amostras

                            <span class="badge badge-secondary ml-2" v-if="coleta">C</span>
                            
                            <span class="badge badge-secondary ml-2" v-if="dados && dados.amostras">
                                {{ dados.amostras.length }}
                            </span>

                            <span class="badge ml-2" :class="'badge-' + dados.marcacao.item_status.cor" v-if="coleta && dados && dados.marcacao && dados.marcacao.item_status && dados.marcacao.dt_inicio.slice(0,10) == $util.hoje()">
                                <i :class="dados.marcacao.item_status.icon" class="mr-2" aria-hidden="true"></i>
                                {{ dados.marcacao.item_status.ultima_etapa.st_etapa_atendimento }}
                            </span>

                            <span v-if="ident_usuario && ident_usuario.login" class="ml-3">
                                {{ ident_usuario.login }}
                            </span>

                            <div class="progress mt-2" v-if="dados && dados.amostras && dados.amostras.length">
                                <div class="progress-bar" role="progressbar" 
                                    :class="status == 'R' ? 'bg-success' : 'bg-warning'"
                                    :style="'width: ' + Math.round( ( lista.length / dados.amostras.length ) * 100 ) + '%'" aria-valuenow="15" aria-valuemin="0" 
                                    aria-valuemax="100" v-for="(lista, status, isx) in lista_status" :key="isx">
                                </div>
                            </div>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <az-loading class="mb-3" v-if="!dados" />

                        <template v-else>
                            <p class="alert alert-danger lead" v-if="lembrete">
                                <i class="fas fa-thumbtack mr-2"></i>
                                {{ lembrete }}
                            </p>

                            <!-- Pagamento Pendente -->
                            <pagamento-pendente 
                                v-if="coleta && dados.paciente.pag_pendentes" 
                                :value="{ id_pessoa: dados.id_paciente, pendentes: dados.paciente.pag_pendentes }" />

                            <ul class="list-group">
                                <li class="list-group-item mb-3">
                                    <div class="row">
                                        <div class="col col-12 col-md-8">
                                            Atendimento  #{{ dados.id_atendimento }}
                                            <span v-if="amostra_id_externo" class="badge badge-secondary">
                                                {{ amostra_id_externo }}
                                            </span>
                                            <span v-else-if="dados.marcacao && dados.marcacao.st_id_externo" class="badge badge-secondary">
                                                {{ dados.marcacao.st_id_externo }}
                                            </span>
                                        </div>
                                        <div class="col col-12 col-md-4 text-right">
                                            {{ $util.getFormatDate(dados.dt_inicio) }}
                                            <span>{{ dados.dt_inicio.substr(11,5) }}</span>
                                        </div>
                                    </div>
                                    <celula-dados-paciente :hor="celulaPaciente" />

                                    <div v-if="dados.internacao">
                                        <!-- Internação -->
                                        <micro-view-internacao class="mt-2" :internacao="dados.internacao" v-if="dados.internacao" />
                                    </div>

                                    <div v-else-if="dados.local_momento" class="alert alert-info py-1 px-2 small mb-0 mt-2">
                                        <i class="fa-solid fa-street-view fa-fw mr-2"></i>
                                        {{ dados.local_momento.search }}
                                    </div>

                                    <div v-else-if="dados.historico && dados.historico.qtde" class="alert alert-secondary py-1 px-2 d-flex justify-content-between small mb-0 mt-2">
                                        <div>
                                            {{ dados.historico.qtde == 1 ? 'Atendimento Anterior' : 'Atendimentos Anteriores' }}: <strong>{{ dados.historico.qtde }}</strong>
                                        </div>
                                        <div>
                                            <div v-if="dados.historico.primeiro == dados.historico.ultimo">
                                                {{ $util.getFormatDate(dados.historico.primeiro) }}
                                            </div>
                                            <div v-else>
                                                {{ $util.getFormatDate(dados.historico.primeiro) }} a {{ $util.getFormatDate(dados.historico.ultimo) }}
                                            </div>
                                        </div>
                                    </div>

                                    <div v-else-if="dados.historico && !dados.historico.qtde" class="alert alert-warning py-1 px-2 d-flex justify-content-between small mb-0 mt-2">
                                        Primeiro atendimento do paciente
                                    </div>
                                </li>

                                <!-- Processo de Atendimento de Coleta -->
                                <template v-if="coleta">

                                    <!-- Botões de Atendimento -->
                                    <div class="mb-3" v-if="dados.dt_inicio.substr(0,10) == $util.hoje() 
                                            && ( dados.marcacao.item_status.ultima_etapa.id_etapa_atendimento == 5
                                            || dados.marcacao.item_status.ultima_etapa.id_etapa_atendimento == 9
                                            || dados.marcacao.item_status.ultima_etapa.id_etapa_atendimento == 10 )">
                                        <div class="d-flex flex-column">
                                            <div class="form-row">
                                                <div class="col col-12 col-md-4 d-flex flex-column">
                                                    <button 
                                                        id="pep-chamar-novamente"
                                                        type="button"
                                                        class="btn btn-outline-danger"
                                                        :disabled="rechamado"
                                                        @click="chamar(dados.marcacao, true)">
                                                        <i class="fas fa-bell mr-2" v-if="!$store.state.loading"></i>
                                                        <div class="spinner-border spinner-border-sm" role="status" v-else>
                                                            <span class="sr-only">Loading...</span>
                                                        </div>
                                                        Chamar Novamente
                                                    </button>
                                                </div>
                                                <div class="col col-12 col-md-4 d-flex flex-column" v-if="dados.marcacao.item_status.ultima_etapa.id_etapa_atendimento == 9">
                                                    <button 
                                                        type="button"
                                                        class="btn btn-outline-success"
                                                        id="pep-iniciar-atendimento"
                                                        @click="retomarAtendimento()">
                                                        <i class="fas fa-play mr-2" v-if="!$store.state.loading"></i>
                                                        <div class="spinner-border spinner-border-sm" role="status" v-else>
                                                            <span class="sr-only">Loading...</span>
                                                        </div>
                                                        Retomar Atendimento
                                                    </button>
                                                </div>
                                                <div class="col col-12 col-md-4 d-flex flex-column" v-else>
                                                    <button 
                                                        type="button"
                                                        class="btn btn-outline-success"
                                                        id="pep-iniciar-atendimento"
                                                        @click="iniciarAtendimento()">
                                                        <i class="fas fa-play mr-2" v-if="!$store.state.loading"></i>
                                                        <div class="spinner-border spinner-border-sm" role="status" v-else>
                                                            <span class="sr-only">Loading...</span>
                                                        </div>
                                                        Iniciar Atendimento
                                                    </button>
                                                </div>
                                                <div class="col col-12 col-md-4 d-flex flex-column">
                                                    <button 
                                                        type="button"
                                                        class="btn btn-outline-secondary"
                                                        id="pep-nao-iniciar-atendimento"
                                                        @click="naoComparecer()">
                                                        <i class="fas fa-times mr-2" v-if="!$store.state.loading"></i>
                                                        <div class="spinner-border spinner-border-sm" role="status" v-else>
                                                            <span class="sr-only">Loading...</span>
                                                        </div>
                                                        Paciente não compareceu
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Botões do Atendimento Iniciado -->
                                    <div class="mb-3" v-else-if="dados.dt_inicio.substr(0,10) == $util.hoje() && dados.marcacao.item_status.ultima_etapa.id_etapa_atendimento == 6">
                                        <div class="d-flex flex-column">
                                            <div class="form-row">
                                                <div class="col col-12 col-md-4 d-flex flex-column">
                                                    <button 
                                                        type="button"
                                                        class="btn btn-danger"
                                                        @click="finalizar()">
                                                        <i class="fas fa-power-off mr-2" v-if="!$store.state.loading"></i>
                                                        <div class="spinner-border spinner-border-sm" role="status" v-else>
                                                            <span class="sr-only">Loading...</span>
                                                        </div>
                                                        Finalizar Atendimento
                                                    </button>
                                                </div>
                                                <div class="col col-12 col-md-4 d-flex flex-column">
                                                    <button 
                                                        type="button"
                                                        class="btn btn-outline-danger"
                                                        @click="cancelar_atendimento()">
                                                        <i class="fa fa-times mr-2" v-if="!$store.state.loading"></i>
                                                        <div class="spinner-border spinner-border-sm" role="status" v-else>
                                                            <span class="sr-only">Loading...</span>
                                                        </div>
                                                        Cancelar Atendimento
                                                    </button>
                                                </div>
                                                <div class="col col-12 col-md-4 d-flex flex-column">
                                                    <button 
                                                        type="button"
                                                        class="btn btn-outline-secondary"
                                                        @click="pausarAtendimento()">
                                                        <i class="fa fa-pause mr-2" v-if="!$store.state.loading"></i>
                                                        <div class="spinner-border spinner-border-sm" role="status" v-else>
                                                            <span class="sr-only">Loading...</span>
                                                        </div>
                                                        Pausar Atendimento
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Botões para Atendimento Finalizado -->
                                    <div class="mb-3" v-else-if="dados.dt_inicio.substr(0,10) == $util.hoje() && dados.marcacao.item_status.ultima_etapa.id_etapa_atendimento == 7">
                                        <div class="d-flex flex-column">
                                            <div class="form-row">
                                                <div class="col col-12 d-flex flex-column">
                                                    <button type="button" class="btn btn-outline-danger btn-sm" @click="reabrir()" :disabled="$store.state.loading">
                                                        <i class="fa fa-play mr-2" aria-hidden="true"></i>
                                                        Reabrir Atendimento
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Leitura de Código de Barras -->
                                    <div class="mb-3" v-if="!viewonly && em_atendimento && dados.amostras.length">
                                        <div class="form-row">
                                            <div class="col col-12 col-md-6">
                                                <az-input
                                                    sizing="sm"
                                                    icon="fa fa-barcode"
                                                    placeholder="Leitura do Código de Barra..."
                                                    v-model="codigo_barra"
                                                    @onEnter="ler_codigo()" />
                                            </div>
                                            <div class="col col-12 col-md-6">
                                                <az-input
                                                    sizing="sm"
                                                    icon="fa fa-search"
                                                    placeholder="Pesquisar..."
                                                    v-model="pesquisa">
                                                    <template v-slot:buttonposb>
                                                        <div class="input-group-append" v-if="tem_curva">
                                                            <button type="button" class="btn" :class="apenas_curva ? 'btn-danger' : 'btn-outline-danger'" @click="apenas_curva = !apenas_curva">
                                                                curva
                                                            </button>
                                                        </div>
                                                    </template>
                                                </az-input>
                                            </div>
                                        </div>
                                    </div>

                                    <template v-else>
                                        <div class="mb-2">
                                            <az-input
                                                sizing="sm"
                                                icon="fa fa-search"
                                                placeholder="Pesquisar..."
                                                v-model="pesquisa">
                                                <template v-slot:buttonposb>
                                                    <div class="input-group-append" v-if="tem_curva">
                                                        <button type="button" class="btn" :class="apenas_curva ? 'btn-danger' : 'btn-outline-danger'" @click="apenas_curva = !apenas_curva">
                                                            curva
                                                        </button>
                                                    </div>
                                                </template>
                                            </az-input>
                                        </div>
                                    </template>

                                </template>

                                <template v-else>
                                    <div class="mb-2">
                                        <az-input
                                            sizing="sm"
                                            icon="fa fa-search"
                                            placeholder="Pesquisar..."
                                            v-model="pesquisa">
                                            <template v-slot:buttonposb>
                                                <div class="input-group-append" v-if="tem_curva">
                                                    <button type="button" class="btn" :class="apenas_curva ? 'btn-danger' : 'btn-outline-danger'" @click="apenas_curva = !apenas_curva">
                                                        curva
                                                    </button>
                                                </div>
                                            </template>
                                        </az-input>
                                    </div>
                                </template>
                                <!-- Fim Coleta -->

                                <!-- AMOSTRAS E EXAMES -->
                                <ul class="nav nav-tabs" id="myTab" role="tablist">
                                    <li class="nav-item" role="presentation">
                                        <a class="nav-link active" id="home-tab" data-toggle="tab" href="#home" role="tab" aria-controls="home" aria-selected="true">
                                            Amostras
                                            <span class="badge badge-secondary ml-2" v-if="lista_amostras.length < dados.amostras.length">
                                                {{ lista_amostras.length }}/{{ dados.amostras.length }}
                                            </span>
                                            <span class="badge badge-secondary ml-2" v-else>
                                                {{ dados.amostras.length }}
                                            </span>
                                        </a>
                                    </li>
                                    <li class="nav-item" role="presentation">
                                        <a class="nav-link" id="profile-tab" data-toggle="tab" href="#profile" role="tab" aria-controls="profile" aria-selected="false">
                                            Exames
                                            <span class="badge badge-secondary ml-2" v-if="lista_exames.length < dados.atendimento_procedimentos.length">
                                                {{ lista_exames.length }}/{{ dados.atendimento_procedimentos.length }}
                                            </span>
                                            <span class="badge badge-secondary ml-2" v-else>
                                                {{ dados.atendimento_procedimentos.length }}
                                            </span>
                                            <span class="text-danger ml-2" v-if="tem_recoleta" title="Paciente com recoleta.">
                                                <i class="fa-solid fa-registered text-danger"></i>
                                            </span>
                                        </a>
                                    </li>
                                    <li class="nav-item" role="presentation">
                                        <a class="nav-link" id="info-tab" data-toggle="tab" href="#info" role="tab" aria-controls="info" aria-selected="false"
                                            v-if="coleta && dados.marcacao.doc_pre_atends && dados.marcacao.doc_pre_atends.length">
                                            Informações Adicionais
                                        </a>
                                    </li>
                                    <li class="nav-item" role="presentation" v-if="dados.log_impressoes && dados.log_impressoes.length">
                                        <a class="nav-link" id="imp-tab" data-toggle="tab" href="#imp" role="tab" aria-controls="imp" aria-selected="false">
                                            Impressões

                                            <span class="badge badge-secondary ml-2">
                                                {{ dados.log_impressoes.length }}
                                            </span>
                                        </a>
                                    </li>
                                    <li class="nav-item" role="presentation" v-if="lista_tipo_etq">
                                        <a class="nav-link" id="etiquetas-tab" data-toggle="tab" href="#etiquetas" role="tab" aria-controls="etiquetas" aria-selected="false">
                                            Etiquetas
                                        </a>
                                    </li>
                                    <li class="nav-item" role="presentation">
                                        <a class="nav-link" id="prazo-tab" data-toggle="tab" href="#prazo" role="tab" aria-controls="prazo" aria-selected="false">
                                            Prazos
                                        </a>
                                    </li>
                                    <li class="nav-item" role="presentation" v-if="dados.outros_pendentes && dados.outros_pendentes.length">
                                        <a class="nav-link text-danger" id="pendentes-tab" data-toggle="tab" href="#pendentes" role="tab" aria-controls="pendentes" aria-selected="false">
                                            <strong>Outros Pendentes</strong>
                                            <span class="badge badge-danger ml-1">
                                                {{ dados.outros_pendentes.length }}
                                            </span>
                                        </a>
                                    </li>
                                    <li class="nav-item" role="presentation">
                                        <a class="nav-link" id="tempos-tab" data-toggle="tab" href="#tempos" role="tab" aria-controls="tempos" aria-selected="false">
                                            Log
                                        </a>
                                    </li>
                                </ul>

                                <div class="tab-content" id="myTabContent">

                                    <!--Lista de Amostras -->
                                    <div class="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
                                        <ul class="list-group">

                                            <az-empty-state class="mt-3" v-if="!lista_amostras.length" msg="Nenhuma amostra identificada." icon="fa-solid fa-vials" />

                                            <template v-else>

                                                <li class="list-group-item list-group-item-secondary d-flex justify-content-between pt-1 pb-2">
                                                    <div>
                                                        <small class="mr-1">Amostras:</small> <span class="badge badge-success">{{ total_amostras }}</span>
                                                        <span class="ml-1" v-if="total_amostras_pendentes > 0">
                                                            <small class="mr-1">/ Pendentes:</small> <span class="badge badge-warning">{{ total_amostras_pendentes }}</span>
                                                        </span>
                                                    </div>
                                                    <div>
                                                        <small class="mr-1">Etiquetas:</small> <span class="badge badge-success">{{ total_etiquetas }}</span>
                                                        <span class="ml-1" v-if="total_etiquetas_pendentes > 0">
                                                            <small class="mr-1">/ Pendentes:</small> <span class="badge badge-warning">{{ total_etiquetas_pendentes }}</span>
                                                        </span>
                                                    </div>
                                                    <div class="text-right" v-if="lista_amostras.length > 1">
                                                        <a href="#" @click.prevent="marcar_todas('P')">
                                                            <i class="fa-solid fa-ban"></i>
                                                        </a>

                                                        <a href="#" @click.prevent="marcar_todas('R')">
                                                            <i class="fa-regular fa-circle ml-2"></i>
                                                        </a>
                                                    </div>
                                                </li>

                                                <li class="list-group-item" v-for="(amostra, iax) in lista_amostras" :key="iax"
                                                    :class="amostra.tem_exames === false ? 'list-group-item-secondary' : 
                                                        ( amostra.status_amostra == 'R' 
                                                            ? 'list-group-item-success' 
                                                            : ( amostra.status_amostra == 'P' ? 'list-group-item-warning' : '' )
                                                        )">
                                                    <div class="row">
                                                        <div class="col col-12 col-md-9 mb-2 mb-md-0">
                                                            <div class="d-flex">
                                                                <a href="#" @click.prevent="exibir_etiqueta(amostra)" v-if="amostra.st_etiqueta">
                                                                    <i class="fa fa-barcode fa-2x mr-2" aria-hidden="true"></i>
                                                                </a>
                                                                <i class="fa fa-barcode fa-2x mr-2" aria-hidden="true" v-else></i>

                                                                <h4 class="mb-0">{{ amostra.search }}</h4>
                                                                <div>
                                                                    <span class="badge badge-dark ml-2" v-if="amostra.material">
                                                                        {{ amostra.material.search }}
                                                                    </span>
                                                                </div>
                                                                <div v-if="amostra.in_qtde_etq > 1">
                                                                    <span class="badge badge-secondary ml-2" title="Quantidade de etiquetas">
                                                                        x{{ amostra.in_qtde_etq }}
                                                                    </span>
                                                                </div>
                                                                <div v-if="amostra.fl_recoleta">
                                                                    <span class="badge badge-danger ml-2">Recoleta</span>
                                                                </div>
                                                            </div>
                                                            <div class="mt-2">
                                                                <span class="badge badge-secondary mr-1">
                                                                    {{ amostra.exames.length }}
                                                                </span>
                                                                <a href="#" @click.prevent="filtrar(exame.atendimento_procedimento.procedimento.st_sigla 
                                                                            ? exame.atendimento_procedimento.procedimento.st_sigla 
                                                                            : exame.atendimento_procedimento.procedimento.st_procedimento)"
                                                                            v-for="(exame, iex) in amostra.exames" :key="iex">
                                                                    <span class="badge mr-1" :class="'badge-' + cor_exame(exame, amostra)">
                                                                        <span v-if="exame.atendimento_procedimento">
                                                                            {{ exame.atendimento_procedimento.procedimento.st_sigla 
                                                                                ? exame.atendimento_procedimento.procedimento.st_sigla 
                                                                                : exame.atendimento_procedimento.procedimento.st_procedimento }}

                                                                            <i class="fa-solid fa-registered" v-if="exame.fl_repeticao" title="Realizar em Outra Amostra"></i>
                                                                            <i class="fa-solid fa-circle-exclamation text-danger" v-if="exame.atendimento_procedimento.fl_urgente" title="Urgente"></i>
                                                                        </span>
                                                                    </span>
                                                                </a>
                                                            </div>
                                                            <div v-if="amostra.rastros && amostra.rastros.length" class="mt-2 small text-muted text-nowrap text-truncate">
                                                                <template v-if="amostra.rastros.length > 1">
                                                                    <a href="#" @click.prevent="toggle_amostra_rastro(amostra)" class="card-link">
                                                                        <i class="fa fa-plus-square-o fa-fw" aria-hidden="true" v-if="!amostra.show_rastro"></i>
                                                                        <i class="fa fa-minus-square-o fa-fw" aria-hidden="true" v-else></i>
                                                                    </a>
                                                                </template>

                                                                {{ amostra.rastros[0].status_rastro.st_amostra_rastro_status }}
                                                                <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                                                {{ $util.getFormatDate(amostra.rastros[0].created_at) }} {{ amostra.rastros[0].created_at.substr(11,5) }}
                                                                <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                                                {{ amostra.rastros[0].usuario.st_login }}

                                                                <span v-if="amostra.rastros[0].js_formulario" class="ml-2">
                                                                    <a href="#" @click.prevent="amostra.rastros[0].fl_ativo = !amostra.rastros[0].fl_ativo" class="card-link" title="Ver Formulário" v-if="!( amostra.rastros.length > 1 )">
                                                                        <i class="fa-solid fa-clipboard-check"></i>
                                                                    </a>

                                                                    <span class="text-muted ml-3">
                                                                        {{ resumo(amostra.rastros[0]) }}
                                                                    </span>
                                                                </span>

                                                                <div v-if="amostra.rastros[0].js_formulario && !amostra.rastros[0].fl_ativo && !( amostra.rastros.length > 1 )" class="mt-2">
                                                                    <formulario :value="amostra.rastros[0].js_formulario" mode="view" />
                                                                </div>

                                                                <div v-if="amostra.show_rastro">
                                                                    <table class="table table-sm bg-white mt-2 mb-0">
                                                                        <template v-for="(rastro, irx) in amostra.rastros">
                                                                            <tr :class="rastro.status_rastro.st_color ? 'table-' + rastro.status_rastro.st_color : ''" v-if="true" :key="irx">
                                                                                <td>
                                                                                    <span v-if="rastro.js_formulario" class="mr-2">
                                                                                        <a href="#" @click.prevent="rastro.fl_ativo = !rastro.fl_ativo" class="card-link" title="Ver Formulário">
                                                                                            <i class="fa-solid fa-clipboard-check"></i>
                                                                                        </a>
                                                                                    </span>
                                                                                    {{ rastro.status_rastro.st_amostra_rastro_status }}
                                                                                </td>
                                                                                <td>
                                                                                    {{ $util.getFormatDate(rastro.created_at) }} {{ rastro.created_at.substr(11,5) }}
                                                                                    <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                                                                    {{ $util.getHumanDuration(rastro.created_at) }}
                                                                                </td>
                                                                                <td>{{ rastro.usuario.st_login }}</td>
                                                                                <td>{{ rastro.st_observacoes }}</td>
                                                                            </tr>

                                                                            <tr  v-if="rastro.js_formulario && !rastro.fl_ativo" :key="'r' + irx">
                                                                                <td colspan="4">
                                                                                    <formulario :value="rastro.js_formulario" mode="view" />
                                                                                </td>

                                                                            </tr>
                                                                        </template>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col col-12 col-md-3 text-right">
                                                            <az-input 
                                                                type="button-group"
                                                                sizing="sm"
                                                                :edicao="pode_editar_amostra(amostra)"
                                                                edicao2="!viewonly && amostra.tem_exames !== false && ( em_atendimento || outra_data ) && ( amostra.status_amostra != 'R' || !tem_laudo_pronto(amostra) ) && !tem_localizacao(amostra)"
                                                                :optionsList="[
                                                                    { id: 'P', search: 'Pendente' },
                                                                    { id: 'R', search: 'Recebida' },
                                                                ]" 
                                                                v-model="amostra.status_amostra" />

                                                            <div class="small text-muted" v-if="amostra.terceiro">
                                                                {{ amostra.terceiro.st_terceiro }}

                                                                <span v-if="amostra.st_destino"> 
                                                                    <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                                                    {{ amostra.st_destino }}
                                                                </span>

                                                                <!-- CURVA -->
                                                                <span v-if="tem_curva_amostra(amostra)" class="badge badge-danger ml-2">
                                                                    curva
                                                                </span>
                                                            </div>

                                                            <div v-else-if="amostra.st_destino" class="small text-muted">
                                                                {{ amostra.st_destino }}
                                                            </div>

                                                            <div title="Volume Urinário" class="small" v-if="amostra.js_info && amostra.js_info.volume">
                                                                {{ amostra.js_info.volume }} ml
                                                                <i class="fa-solid fa-glass-water fa-fw ml-2"></i>
                                                            </div>

                                                            <div title="Tempo Diurese" class="small" v-if="amostra.js_info && amostra.js_info.tempo">
                                                                {{ amostra.js_info.tempo }} h
                                                                <i class="fa-solid fa-stopwatch fa-fw ml-2"></i> 
                                                            </div>

                                                            <div v-if="amostra.dt_coleta" class="small">
                                                                <a href="#" @click.prevent="alterar_data_coleta(amostra)" class="card-link">
                                                                    Coleta: {{ $util.getFormatDate(amostra.dt_coleta) }} {{ amostra.dt_coleta.slice(11,16) }}
                                                                </a>
                                                            </div>

                                                            <div v-else-if="amostra.status_amostra == 'R'" class="small">
                                                                <a href="#" @click.prevent="alterar_data_coleta(amostra)" class="card-link">
                                                                    Coleta
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="mt-3" v-if="amostra.st_etiqueta && amostra.show_etiqueta">
                                                        <pre>{{ amostra.st_etiqueta }}</pre>
                                                    </div>
                                                </li>

                                            </template>
                                        </ul>

                                        <div class="mt-3">
                                            <az-input
                                                v-if="tem_amostra_inativa"
                                                type="checkbox-group"
                                                sizing="sm"
                                                label="Apenas amostras ativas"
                                                v-model="apenas_ativas" />
                                        </div>
                                    </div>

                                    <!-- Exames -->
                                    <div class="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">

                                        <div class="text-right mt-2">
                                            <!-- Coletar / Não Coletar -->
                                            <a href="#" @click.prevent="coletar_todos(true)" title="Marcar todos como coletar.">
                                                <i class="fa fa-circle-o mr-3" aria-hidden="true"></i>
                                            </a>

                                            <a href="#" @click.prevent="coletar_todos(false)" title="Marcar todos como não coletar.">
                                                <i class="fa fa-ban mr-3" aria-hidden="true"></i>
                                            </a>

                                            <!-- Ordem -->
                                            <a href="#" @click.prevent="ordem = 'A'" v-if="ordem == 'L'" title="Ordem de lançamento">
                                                <i class="fa-solid fa-arrow-down-1-9"></i>
                                            </a>
                                            <a href="#" @click.prevent="ordem = 'L'" v-else title="Ordem alfabética">
                                                <i class="fa-solid fa-arrow-down-a-z" ></i>
                                            </a>
                                        </div>
                                        <ul class="list-group">
                                            <li class="list-group-item d-flex justify-content-between hover-bg" 
                                                :class="atp.nao_coletar ? 'list-group-item-warning' : ''"
                                                v-for="(atp, iax) in lista_exames" 
                                                :key="iax">

                                                <div>
                                                    <i class="fa fa-ban fa-fw mr-2" aria-hidden="true" v-if="atp.nao_coletar"></i>
                                                    {{ atp.procedimento.search }}

                                                    <a href="#" @click.prevent="filtrar(atp.procedimento.st_sigla)" v-if="atp.procedimento.st_sigla">
                                                        <span class="badge badge-secondary ml-2">
                                                            {{ atp.procedimento.st_sigla }}
                                                        </span>
                                                    </a>

                                                    <span v-if="atp && atp.js_solics && atp.js_solics.recoleta" class="text-danger ml-2" title="Recoleta">
                                                        <i class="fa-solid fa-registered"></i>
                                                    </span>

                                                    <span v-if="atp && atp.js_solics && atp.js_solics.terc == 'S'" class="text-info ml-2" title="Terceirizado">
                                                        <i class="fa-solid fa-location-pin"></i>
                                                    </span>

                                                    <span class="badge badge-danger ml-2" v-if="atp.fl_urgente">
                                                        Urgente
                                                    </span>

                                                    <span v-if="!atp.nao_coletar && atp.trocou && atp.nova_amostra" class="ml-2" title="Coletar nova amostra">
                                                        <i class="fa-solid fa-vial-circle-check fa-fw"></i>
                                                    </span>

                                                    <div v-if="atp.amostra && !atp.trocar_material" class="small text-muted">
                                                        {{ atp.nome_material ? atp.nome_material : atp.amostra.search }}
                                                    </div>
                                                    <div v-else-if="atp.trocar_material" class="small text-muted">
                                                        <az-input   
                                                            sizing="sm"
                                                            placeholder="Selecionar Material..."
                                                            type="select" 
                                                            :optionsList="ordenar_amostras(atp.procedimento.amostras)"
                                                            optionsData="id_amostra_material"
                                                            v-model="atp.id_amostra_material" />

                                                        <az-input   
                                                            sizing="sm"
                                                            placeholder="Descrição do Material..."
                                                            v-if="atp.id_amostra_material && atp.js_solics && dados && ( ( dados.id_amostra_material_diversos && dados.id_amostra_material_diversos[atp.id_amostra_material] ) || ( atp.js_solics.oa ) )"
                                                            v-model="atp.js_solics.amo" />
                                                    </div>
                                                    <div class="small text-muted" v-if="atp.dt_entrega">
                                                        Entrega: {{ $util.getFormatDate(atp.dt_entrega) }}
                                                        <span v-if="atp.dt_entrega && atp.dt_entrega.slice(11,16) != '00:00'">
                                                            {{ atp.dt_entrega.slice(11,16) }}
                                                        </span>
                                                        <i class="fa-solid fa-triangle-exclamation ml-2" v-if="atp.js_solics && atp.js_solics.dte" title="Data reprogramada"></i>
                                                    </div>

                                                    <div v-if="!atp.amostra_atendimento_procedimento" class="small text-danger">
                                                        <i class="fa-solid fa-triangle-exclamation mx-2"></i> 
                                                        Nenhuma amostra gerada para o exame.
                                                    </div>
                                                </div>

                                                <div>

                                                    <button type="button" class="btn btn-secondary btn-sm mr-2" @click="abrir_help(atp)" title="Help de Exame" v-if="dados.tem_klis">
                                                        <i class="fa-solid fa-circle-info"></i>
                                                    </button>
                                                    
                                                    <button type="button" class="btn btn-secondary btn-sm mr-2" @click="abrir_obs(atp)">
                                                        <i class="fa-solid fa-comment"></i>
                                                        <span class="badge badge-light ml-2" v-if="atp.obss && atp.obss.length">
                                                            {{ atp.obss.length }}
                                                        </span>
                                                    </button>

                                                    <button type="button" class="btn btn-secondary btn-sm mr-2" @click="rastreabilidade_exame(atp)" title="Rastreabilidade / Linha do Tempo">
                                                        <i class="fa-solid fa-stopwatch fa-fw"></i>
                                                    </button>

                                                    <!-- Opções para o Exame -->
                                                    <div class="btn-group dropleft" v-if="!viewonly">
                                                        <button type="button" class="btn btn-secondary btn-sm dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                            Ações
                                                        </button>
                                                        <div class="dropdown-menu">
                                                            <!-- Coletar em Nova Amostra -->
                                                            <a class="dropdown-item" href="#" v-if="show_menu_coleta_nova_mostra(atp)"
                                                                @click.prevent="atp.nao_coletar = !atp.nao_coletar; atp.trocou = true; atp.nova_amostra = true;">
                                                                <i class="fa-solid fa-vial-circle-check fa-fw mr-2"></i>
                                                                Coletar (Nova Amostra)
                                                            </a>

                                                            <a class="dropdown-item" href="#"
                                                                @click.prevent="atp.nao_coletar = !atp.nao_coletar; atp.trocou = true; atp.nova_amostra = false;">
                                                                <i class="fa-regular fa-circle fa-fw mr-2" v-if="atp.nao_coletar"></i>
                                                                <i class="fas fa-ban fa-fw mr-2" v-else></i>
                                                                {{ atp.nao_coletar ? '' : 'Não' }}
                                                                Coletar
                                                            </a>

                                                            <a class="dropdown-item" href="#" @click.prevent="reprogramar_entrega(atp, iax)">
                                                                <i class="fa-solid fa-calendar-day fa-fw mr-2"></i>
                                                                Reprogramar Entrega
                                                            </a>
                                                            <a class="dropdown-item" href="#" @click.prevent="toggle_urgencia(atp, iax)">
                                                                <i class="fa-solid fa-circle-exclamation fa-fw mr-2" :class="atp.fl_urgente ? 'text-danger' : 'text-secondary'"></i>
                                                                {{ atp.fl_urgente ? 'Retirar Urgência' : 'Marcar como Urgente' }}
                                                            </a>
                                                            <a class="dropdown-item" href="#" @click.prevent="trocar_material(iax)" v-if="atp.procedimento.amostras && atp.procedimento.amostras.length > 1">
                                                                <i class="fa-solid fa-flask-vial fa-fw mr-2"></i>
                                                                Trocar Material
                                                            </a>
                                                            <a class="dropdown-item" href="#" @click.prevent="gerar_etiqueta(atp)" v-if="atp.procedimento.id_classe_procedimento == 20">
                                                                <i class="fa-solid fa-circle-plus fa-fw mr-2"></i>
                                                                Gerar Etiqueta
                                                            </a>


                                                            <template  v-if="1==0 && $store.state.user.id_usuario == 1 && !atp.nao_coletar">
                                                                <div class="dropdown-divider"></div>
                                                                <a class="dropdown-item" href="#" @click.prevent="alterar_data_coleta(atp, iax)">
                                                                    <i class="fa-regular fa-calendar-check fa-fw mr-2"></i>
                                                                    Alterar Data da Coleta
                                                                </a>
                                                            </template>

                                                            <div class="dropdown-divider"></div>
                                                            <a class="dropdown-item" href="#" @click.prevent="$util.logAudit('laudo', atp.laudo.id_laudo)" v-if="atp.laudo">
                                                                <i class="fa-solid fa-book fa-fw mr-2"></i>
                                                                Log
                                                            </a>
                                                        </div>
                                                    </div>
                                                
                                                </div>
                                            </li>
                                        </ul>
                                    </div>

                                    <!--Informações Adicionais -->
                                    <div class="tab-pane fade" id="info" role="tabpanel" aria-labelledby="info-tab">

                                        <div class="mt-3" v-if="coleta && dados.marcacao.doc_pre_atends && dados.marcacao.doc_pre_atends.length">
                                            <pre-atendimento-edit 
                                                v-model="dados.marcacao.doc_pre_atends" 
                                                :validate="validate" 
                                                :view="!coleta || !em_atendimento" />
                                            <br><br>
                                        </div>

                                    </div>

                                    <!--Impressões -->
                                    <div class="tab-pane fade" id="imp" role="tabpanel" aria-labelledby="imp-tab">
                                        <div class="mt-3" v-if="dados && dados.log_impressoes">
                                            <table class="table table-hover">
                                                <thead>
                                                    <tr>
                                                        <th>Data</th>
                                                        <th>Usuário</th>
                                                        <th>Tipo</th>
                                                        <th>Descrição</th>
                                                        <th>Local</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(log, ilx) in dados.log_impressoes" :key="ilx">
                                                        <td>
                                                            {{ $util.getFormatDate(log.created_at) }}
                                                            {{ log.created_at.slice(11,16) }}
                                                        </td>
                                                        <td>{{ log.usuario.st_login }}</td>
                                                        <td>{{ log.st_tipo }}</td>
                                                        <td>{{ log.st_descricao }}
                                                            <span class="ml-1 text-muted small" v-if="log.st_observacoes">
                                                                <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                                                {{ log.st_observacoes }}
                                                            </span>
                                                        </td>
                                                        <td>{{ log.st_servidor_impressao }}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>

                                    <!-- Exames -->
                                    <div class="tab-pane fade" id="etiquetas" role="tabpanel" aria-labelledby="etiquetas-tab">

                                        <div class="mt-3">
                                            <ul class="list-group">
                                                <li class="list-group-item" v-for="(etqs, grupo, igx) in lista_tipo_etq" :key="grupo">
                                                    <div class="d-flex justify-content-between">
                                                        <div>
                                                            <a class="card-link" data-toggle="collapse" :href="'#collapseGrupoEtq' + igx" role="button" aria-expanded="false" aria-controls="collapseExample">
                                                                {{ etqs[0].tipo_etq.search }}
                                                            </a>
                                                        </div>
                                                        <div>
                                                            x{{ etqs.length }}

                                                            <span v-if="etqs[0].tipo_etq.st_sigla" class="badge badge-primary ml-2">
                                                                <span v-if="etqs[0].tipo_etq.st_icon">
                                                                    <i :class="etqs[0].tipo_etq.st_icon"></i>
                                                                </span>
                                                                <span v-else>
                                                                    {{ etqs[0].tipo_etq.st_sigla }}
                                                                </span>
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div class="px-3 mt-2 collapse show" :id="'collapseGrupoEtq' + igx">
                                                        <ul class="list-group">
                                                            <li class="list-group-item" v-for="(etq, iex) in etqs" :key="iex">
                                                                <div class="d-flex justify-content-between">
                                                                    <div>
                                                                        {{ etq.st_codigo }}
                                                                        <a href="#" @click.prevent="editar_titulo(etq)" class="ml-2 small card-link">
                                                                            {{ etq.st_destino ? etq.st_destino : '-' }}
                                                                        </a>
                                                                    </div>
                                                                    <div>
                                                                        {{ iex + 1 }}/{{ etqs.length }}

                                                                        <a href="#" @click.prevent="remover_etiqueta_amostra(etq)" class="ml-3" title="Remover Etiqueta" v-if="etq.fl_ativo">
                                                                            <i class="fa fa-times text-danger" aria-hidden="true"></i>
                                                                        </a>
                                                                    </div>
                                                                </div> 
                                                                <div v-if="etq.destino_amostra && etq.destino_amostra.length" class="mt-2">
                                                                    <ul>
                                                                        <li v-for="(dest, dix) in etq.destino_amostra" :key="dix">
                                                                            {{ dest.search }} 
                                                                            <span v-if="dest.st_destino" class="ml-2 small text-muted">
                                                                                {{ dest.st_destino }}
                                                                            </span>
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                                <div v-else-if="etq.origem_amostra" class="mt-2 small text-muted">
                                                                    <span class="ml-3">
                                                                        {{ etq.origem_amostra.search }} 
                                                                        <span v-if="etq.origem_amostra.st_destino" class="ml-2">
                                                                            {{ etq.origem_amostra.st_destino }}
                                                                        </span>
                                                                    </span>
                                                                </div>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>

                                    </div>

                                    <!--Prazos -->
                                    <div class="tab-pane fade" id="prazo" role="tabpanel" aria-labelledby="prazo-tab">

                                        <div class="mt-3" v-if="dados">
                                            <exibir-lab-logins :marcacao="{ ...dados.marcacao, atendimento: dados }" :exibir_prazo="true" />
                                        </div>

                                    </div>

                                    <!-- Outros Pendentes -->
                                    <div class="tab-pane fade" id="pendentes" role="tabpanel" aria-labelledby="pendentes-tab">

                                        <div class="list-group" v-if="dados.outros_pendentes">
                                            <button type="button" class="list-group-item list-group-item-action d-flex justify-content-between" v-for="(outro, iox) in dados.outros_pendentes" :key="iox" @click="abrir(outro.id_atendimento)">
                                                <div>
                                                    #{{ outro.id_atendimento }}, {{ $util.getFormatDate(outro.dt_inicio) }}
                                                    <span class="badge badge-light ml-3" v-if="outro.unidade_operacao && outro.unidade_operacao.st_sigla">
                                                        {{ outro.unidade_operacao.st_sigla }}
                                                    </span>
                                                </div>
                                                <div>
                                                    <span class="badge badge-secondary">
                                                        {{ outro.atendimento_procedimentos_count }}
                                                    </span>
                                                </div>
                                            </button>
                                        </div>
                                    </div>

                                    <!--Tempos -->
                                    <div class="tab-pane fade" id="tempos" role="tabpanel" aria-labelledby="tempos-tab">

                                        <div class="mt-3" v-if="dados && dados.atendimento_outros">
                                            <table class="table">
                                                <tr>
                                                    <td>{{ $util.getFormatDate(dados.dt_inicio) }}</td>
                                                    <td>Atendimento</td>
                                                    <td>{{ dados.marcacao.item_status ? dados.marcacao.item_status.valor : '' }}</td>
                                                    <td>
                                                        <div v-if="dados.marcacao && dados.marcacao.atendimento && dados.marcacao.atendimento.progresso_atendimentos">
                                                            <ul>
                                                                <li v-if="dados.usuario && dados.marcacao.atendimento.dt_inicio">
                                                                    {{ $util.getFormatDate(dados.marcacao.atendimento.dt_inicio) }}
                                                                    {{ dados.marcacao.atendimento.dt_inicio.slice(11,16) }} |
                                                                    Cadastro | 
                                                                    {{ dados.usuario.st_login }}
                                                                </li>
                                                                <li v-for="(prog, ipx) in dados.marcacao.atendimento.progresso_atendimentos" :key="ipx">
                                                                    {{ $util.getFormatDate(prog.dt_conclusao) }}
                                                                    {{ prog.dt_conclusao.slice(11,16) }} |
                                                                    {{ prog.etapa_atendimento.st_etapa_atendimento }} | 
                                                                    {{ prog.usuario.st_login }}
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr v-for="(atdoutro, aox) in dados.atendimento_outros" :key="aox">
                                                    <td>{{ $util.getFormatDate(atdoutro.dt_inicio.slice(0,10)) }}</td>
                                                    <td>{{ atdoutro.st_observacoes }}</td>
                                                    <td><span v-if="atdoutro.etapa">{{ atdoutro.etapa.st_etapa_atendimento }}</span></td>
                                                    <td>
                                                        <div v-if="atdoutro.progressos">
                                                            <ul>
                                                                <li v-if="atdoutro.usuario && atdoutro.created_at">
                                                                    {{ $util.getFormatDate(atdoutro.created_at) }}
                                                                    {{ atdoutro.created_at.slice(11,16) }} |
                                                                    Cadastro | 
                                                                    {{ atdoutro.usuario.st_login }}
                                                                </li>
                                                                <li v-for="(prog, ipx) in atdoutro.progressos" :key="ipx">
                                                                    {{ $util.getFormatDate(prog.dt_conclusao) }}
                                                                    {{ prog.dt_conclusao.slice(11,16) }} |
                                                                    {{ prog.etapa.st_etapa_atendimento }} | 
                                                                    {{ prog.usuario.st_login }}
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </table>

                                            <hr> 

                                            <pre v-if="false">{{ dados.atendimento_outros }}</pre>
                                        </div>

                                    </div>

                                </div>

                            </ul>

                            <pre v-if="false">{{ dados }}</pre>
                        </template>
                        
                    </div>
                    <div class="modal-footer" v-if="dados">
                        <div v-if="!viewonly">
                            <laboratorio-etiqueta 
                                :pre_integracao="pre_integrar"
                                :canto="true"
                                :fila="true"
                                :value="{ 
                                    id_marcacao: dados.marcacao.id_marcacao, 
                                    atendimento: dados, 
                                    dt_inicio: dados.dt_inicio,
                                    item_status: dados.marcacao.item_status, 
                                    procedimento: dados.atendimento_procedimento ?  dados.atendimento_procedimento.procedimento : null, 
                                }" 
                                :horabase="horabase"
                                :encup="true"
                                @emitida="refresh_se_necessario" />
                        </div>
                        <button type="button" class="btn btn-outline-primary ml-1" title="Instruções" @click="abrir_instrucoes()">
                            <i class="fa-solid fa-circle-info"></i>
                        </button>
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit v-if="!viewonly" @click="atualizar()">Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal Data de Entrega -->
        <div class="modal fade" id="dtEntregaModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content" v-if="nova_entrega">
                    <div class="modal-header">
                        <h5 class="modal-title">Reprogramar Entrega</h5>
                        <button type="button" class="close" @click="fechar_modal('dtEntregaModal')" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="alert alert-info">
                            {{ nova_entrega.procedimento.search }}
                        </div>
                        <az-input
                            type="datetime-local"
                            required
                            v-model="nova_entrega.dt_entrega" />
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="fechar_modal('dtEntregaModal')">Fechar</button>
                        <button type="button" class="btn btn-success" @click="selecionar_entrega()">Selecionar</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal Instruções -->
        <div class="modal fade" :id="'instrucoesAmostraModal' + nome_base" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Instruções</h5>
                        <button type="button" class="close" @click="fechar_modal('instrucoesAmostraModal' + nome_base)" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <az-instrucoes contexto="R" ref="instrucoesamostra" />
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="fechar_modal('instrucoesAmostraModal' + nome_base)">Fechar</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Alterar Data Coleta -->
        <div class="modal fade" id="alterarColetaModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Data da Coleta</h5>
                        <button type="button" class="close" @click="fechar_modal('alterarColetaModal')" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="edicao_coleta">
                        <div class="alert alert-info">
                            {{ edicao_coleta.st_codigo }}
                        </div>

                        <az-input 
                            label="Data/Hora da Coleta"
                            type="datetime-local"
                            v-model="edicao_coleta.dt_coleta" />
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="fechar_modal('alterarColetaModal')">Cancelar</button>
                        <az-submit @click="atualizar_data_coleta()">Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal Criar Etiqueta -->
        <div class="modal fade" id="gerarEtiquetaModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Gerar Etiqueta</h5>
                        <button type="button" class="close" @click="fechar_modal('gerarEtiquetaModal')" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="edicao_atp_etq">
                        <div class="form-row">
                            <div class="col col-12">
                                <az-input
                                    type="select"
                                    label="Tipo de Etiqueta"
                                    optionsMode="aql"
                                    service="tipo_etiqueta_amostras.index"
                                    optionsData="id_tipo_etiqueta_amostra"
                                    :optionsParm="{ ativos: true }"
                                    required
                                    :validate="validate"
                                    v-model="edicao_atp_etq.id_tipo_etiqueta_amostra" />
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="col col-12">
                                <az-input
                                    type="number"
                                    label="Quantidade"
                                    required
                                    :validate="validate"
                                    v-model="edicao_atp_etq.in_quantidade" />
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="fechar_modal('gerarEtiquetaModal')">Cancelar</button>
                        <az-submit @click="salvar_gerar_etiqueta()">Gerar</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal Edição de Título -->
        <div class="modal fade" id="editarTituloModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Editar</h5>
                        <button type="button" class="close" @click="fechar_modal('editarTituloModal')" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="edicao_titulo">
                        <div class="alert alert-info d-flex justify-content-between">
                            <div>{{ edicao_titulo.st_titulo }}</div>
                            <div>{{ edicao_titulo.st_codigo }}</div>
                        </div>

                        <az-input
                            label="Informação Etiqueta"
                            v-model="edicao_titulo.st_destino" />
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="fechar_modal('editarTituloModal')">Cancelar</button>
                        <az-submit @click="atualizar_titulo()">Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <observacoes ref="obs" @refresh="carregar(dados.id_atendimento)" />
        <rastreabilidade-exame ref="rastreabilidade" />
        <re-identificacao-de-usuario ref="ident_user" />
        <ciente-instrucoes ref="ciente" :nocancel="true" />
        <pausar-atendimento ref="pausar" :modal_base="nome_base" />
        <help-exame-klis ref="help" />
        <gerar-etiqueta-a-p ref="etq_ap" :amostras="lista_amostras" @refresh="carregar(dados.id_atendimento)" />

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import * as moment from "moment";
import CelulaDadosPaciente from '../../shared/table/CelulaDadosPaciente.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import LaboratorioEtiqueta from '../recepcao/LaboratorioEtiqueta.vue';
import AzLoading from '../../util/AzLoading.vue';
import PreAtendimentoEdit from '../recepcao/PreAtendimentoEdit.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import Observacoes from '../../shared/Observacoes.vue';
import RastreabilidadeExame from './RastreabilidadeExame.vue';
import ReIdentificacaoDeUsuario from '../../shared/ReIdentificacaoDeUsuario.vue';
import AzInstrucoes from '../../util/AzInstrucoes.vue';
import CienteInstrucoes from '../recepcao/CienteInstrucoes.vue';
import ExibirLabLogins from '../recepcao/ExibirLabLogins.vue';
import PausarAtendimento from './PausarAtendimento.vue';
import PagamentoPendente from '../../shared/PagamentoPendente.vue';
import HelpExameKlis from '../recepcao/HelpExameKlis.vue';
import GerarEtiquetaAP from './GerarEtiquetaAP.vue';
import Formulario from '../consultorio/Formulario.vue';
import MicroViewInternacao from '../internacao/MicroViewInternacao.vue';

export default {
    data() { 
        return { 
            dados: null, 
            codigo_barra: "", 
            rechamado: false, 
            validate: false,
            ordem: "L",
            nova_entrega: null, 
            pesquisa: "", 
            ident_usuario: null, 
            reident_user: false, 
            apenas_ativas: true, 
            horabase: null, 
            nome_base: "",
            apenas_curva: false, 
            callback_ident: null, 
            edicao_coleta: null, 
            edicao_atp_etq: null, 
            edicao_titulo: null, 
        }
    },

    components: { 
        AzInput, 
        AzSubmit, 
        CelulaDadosPaciente, 
        LaboratorioEtiqueta, 
        AzLoading, 
        PreAtendimentoEdit, 
        AzEmptyState, 
        Observacoes, 
        RastreabilidadeExame, 
        ReIdentificacaoDeUsuario, 
        AzInstrucoes, 
        CienteInstrucoes, 
        ExibirLabLogins, 
        PausarAtendimento, 
        PagamentoPendente, 
        HelpExameKlis, 
        GerarEtiquetaAP, 
        Formulario,
        MicroViewInternacao,
    },

    props: ['viewonly', 'coleta'],

    computed: { 
        total_amostras: function () { 
            return this.lista_amostras.filter(item => item.status_amostra != 'P').length;
        },

        total_amostras_pendentes: function () { 
            return this.lista_amostras.filter(item => item.status_amostra == 'P').length;
        },

        total_etiquetas: function () { 
            return this.lista_amostras.filter(item => item.status_amostra != 'P')
                .reduce((total, item) => total + (item.in_qtde_etq ? item.in_qtde_etq : 1), 0);
        },

        total_etiquetas_pendentes: function () { 
            return this.lista_amostras.filter(item => item.status_amostra == 'P')
                .reduce((total, item) => total + (item.in_qtde_etq ? item.in_qtde_etq : 1), 0);
        },

        tem_curva: function () { 
            if ( !this.dados || !this.dados.atendimento_procedimentos )
                return false;

            return this.dados.atendimento_procedimentos.find(item => item.js_solics && item.js_solics.curv ) ? true : false;
        },

        lembrete: function () { 
            return _.get(this.dados, 'paciente.paciente_unidade.st_lembrete', '?');
        },

        tem_amostra_inativa: function () { 
            if ( !this.dados || !this.dados.amostras )
                return false;

            return this.dados.amostras.find(item => !item.tem_exames) ? true : false;
        },

        lista_amostras: function () { 
            if ( !this.dados || !this.dados.amostras )
                return [];

            let reg = this.$util.getregex(this.pesquisa);

            return this.dados.amostras.filter(item => { 
                return ( !this.pesquisa || reg.test(JSON.stringify(item)) ) 
                    && ( !this.apenas_ativas || item.tem_exames )
                    && ( !this.apenas_curva || this.tem_curva_amostra(item) );
            });
        },

        celulaPaciente: function () { 
            if ( !this.dados )
                return;

            return { 
                marcacao: this.dados, 
            };
        },

        lista_status: function () { 
            if ( !this.dados )
                return [];

            return _.groupBy(this.dados.amostras, 'status_amostra');
        },

        amostra_id_externo: function() { 
            return _.get(this.dados, 'amostras.0.st_id_externo');
        },

        outra_data: function () { 
            return ( this.dados && this.dados.marcacao && this.dados.marcacao.dt_inicio && this.dados.marcacao.dt_inicio.slice(0,10) != this.$util.hoje() );
                
        },

        em_atendimento: function () { 
            return !this.coleta 
                ||  this.dados.marcacao.item_status.ultima_etapa.id_etapa_atendimento == 6;
        },

        lista_exames: function () { 
            let reg = this.$util.getregex(this.pesquisa);

            let lista = this.dados.atendimento_procedimentos.filter(item => { 
                return !this.pesquisa || reg.test(JSON.stringify(item));
            });

            return _.orderBy(
                lista,
                this.ordem == 'L' ? 'id_atendimento_procedimento' : 'procedimento.search'
            );
        },

        tem_recoleta: function () { 
            return this.dados.atendimento_procedimentos.find(item => item.js_solics && item.js_solics.recoleta) ? true : false;
        },

        lista_tipo_etq: function () {
            let amostras_tipo = this.lista_amostras.filter(amostra => amostra.id_tipo_etiqueta_amostra);

            if ( !amostras_tipo.length ) { 
                return;
            }

            return _.groupBy(amostras_tipo, 'id_tipo_etiqueta_amostra');
        }
    },

    methods: { 
        resumo (rastro) { 
            if ( !rastro || !rastro.js_formulario || !rastro.js_formulario.length )
                return '';

            return rastro.js_formulario.filter(campo => campo.value)
                .map(campo => {
                    return `${campo.label}: ${campo.value}`;
                })
                .join(' | ');
        },

        remover_etiqueta_amostra (amostra) { 
            if ( !confirm('Confirma remover esta etiqueta (' + amostra.st_codigo + ' / ' + amostra.st_titulo + ')?' ) ) { 
                return;
            }

            this.$util.atualizar(this, { 
                service: 'amostras', 
                func: 'remover_etiqueta_amostra',
                dados: { 
                    id_amostra: amostra.id_amostra, 
                }, 
                toast: true,
                callback: () => { 
                    this.carregar(this.dados.id_atendimento);
                }
            });
        },

        atualizar_titulo () { 
            this.$util.atualizar(this, { 
                service: 'amostras', 
                func: 'atualizar_destino', 
                dados: { 
                    id_amostra: this.edicao_titulo.id_amostra,
                    st_destino: this.edicao_titulo.st_destino,
                },
                modal: 'editarTituloModal',
                toast: true,
                callback: () => { 
                    this.carregar(this.dados.id_atendimento);
                }
            });
        },

        editar_titulo (etq) { 
            this.edicao_titulo = _.cloneDeep(etq);
            $('#editarTituloModal').modal('show');
        },

        show_menu_coleta_nova_mostra (atp) { 
            if ( !atp || !atp.nao_coletar ) { 
                return false; 
            }

            if ( atp.amostra_atendimento_procedimento && atp.amostra_atendimento_procedimento.amostra ) { 
                if ( atp.amostra_atendimento_procedimento.amostra.fl_pendente ) { 
                    return false; 
                }

                let dt_coleta = atp.amostra_atendimento_procedimento.amostra.dt_coleta; 

                if ( !dt_coleta ) { 
                    dt_coleta = ( ( this.dados && this.dados.dt_inicio ) ? this.dados.dt_inicio : null ); 
                }

                if ( dt_coleta && ( dt_coleta.slice(0,10) < this.$util.hoje() ) ) { 
                    return true;
                }

            }

            return false; 

        },

        gerar_etiqueta (atp) { 
            this.$refs.etq_ap.abrir(atp);

            /*
            this.validate = false; 

            this.edicao_atp_etq = { 
                id_atendimento_procedimento: atp.id_atendimento_procedimento,
                id_tipo_etiqueta_amostra: null,
                in_quantidade: 1,
            };

            $('#gerarEtiquetaModal').modal('show');
            */
        },

        salvar_gerar_etiqueta () { 
            this.$util.atualizar(this, { 
                service: 'amostras',
                func: 'gerar_tipo_etiquetas_amostra',
                dados: this.edicao_atp_etq,
                toast: true, 
                modal: 'gerarEtiquetaModal',
                callback: () => { 
                    this.carregar(this.dados.id_atendimento);
                }
            });
        },

        alterar_data_coleta (amostra) { 
            this.edicao_coleta = _.cloneDeep(amostra);
            $('#alterarColetaModal').modal('show');
        },

        atualizar_data_coleta() { 
            this.$util.atualizar(this, { 
                service: 'amostras',
                func: 'alterar_data_coleta',
                dados: { 
                    id_amostra: this.edicao_coleta.id_amostra,
                    dt_coleta: this.edicao_coleta.dt_coleta,
                },
                toast:true, 
                modal: 'alterarColetaModal',
                callback: () => { 
                    this.carregar(this.dados.id_atendimento);
                }
            });
        },

        abrir_help (atp) { 
            this.$refs.help.abrir_procedimento(atp.id_procedimento);
        },

        ordenar_amostras(amostras) { 
            return _.orderBy(amostras, 'search');
        },

        exibir_etiqueta (amostra) { 
            amostra.show_etiqueta = !amostra.show_etiqueta;
            console.log('amostra', amostra);
        },

        pode_editar_amostra(amostra) { 
            return !this.viewonly 
                && amostra.tem_exames !== false 
                && ( this.em_atendimento || this.outra_data ) 
                && ( amostra.status_amostra != 'R' || !this.tem_laudo_pronto(amostra) ) 
                && !this.tem_localizacao(amostra);
        },

        marcar_todas (tipo) { 
            this.lista_amostras.forEach(amostra => { 
                if ( this.pode_editar_amostra(amostra) ) { 
                    amostra.status_amostra = tipo;
                }
            });
        },

        naoComparecer() { 
            if ( !confirm('Confirma registrar o não comparecimento do paciente a chamada?') ) 
                return;

            this.$util.atualizar(this, { 
                service: 'atendimentos',
                func: 'pausar',
                dados: { 
                    id: this.dados.id_atendimento, 
                    nao_compareceu: true, 
                },
                callback: () => { 
                    $('.modal').modal('hide');
                    this.$emit('refresh');
                }
            });

        },

        tem_curva_amostra (amostra) { 
            if ( !amostra || !amostra.exames )
                return false;

            return amostra.exames.find(item => item.atendimento_procedimento && item.atendimento_procedimento.js_solics && item.atendimento_procedimento.js_solics.curv ) ? true : false;
        },

        uuidv4() {
            return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
                (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
            );
        },

        abrir_instrucoes () { 
            this.$refs.instrucoesamostra.reset();
            this.$refs.instrucoesamostra.buscar_plano({ ...this.dados, atendimento: this.dados });

            $("#instrucoesAmostraModal" + this.nome_base).modal("show"); 
        },
        coletar_todos (coleta) { 
            if ( !confirm('Confirma marcar os exames para ' + ( coleta ? 'COLETAR' : 'NÃO COLETAR' ) + '?') ) { 
                return;
            }

            this.lista_exames.forEach(atp => {
                if ( atp.nao_coletar != !coleta ) { 
                    atp.nao_coletar = !coleta;
                    atp.trocou = true;
                }
            });
        },

        filtrar (texto) { 
            if ( this.pesquisa == '"' + texto + '"' ) { 
                this.pesquisa = "";
            } else { 
                this.pesquisa = '"' + texto + '"';
            }
        },

        trocar_material (index) { 
            this.lista_exames[index].trocar_material = !this.lista_exames[index].trocar_material;
            this.$forceUpdate();
        },

        rastreabilidade_exame (atp) { 
            this.$refs.rastreabilidade.abrir(atp, this.dados);
        },

        toggle_amostra_rastro (amostra) { 
            amostra.show_rastro = !amostra.show_rastro;
            this.$forceUpdate();
        },

        selecionar_entrega () { 
            if ( this.nova_entrega && !this.nova_entrega.dt_entrega ) { 
                this.$toast.add({
                    severity: "error",
                    summary: "Reprogramar",
                    detail: "Data de entrega não informada.",
                    life: 3000
                });
                return;
            }

            if ( this.nova_entrega.dt_entrega.substr(0,10) < this.dados.marcacao.dt_inicio.substr(0,10) ) { 
                this.$toast.add({
                    severity: "error",
                    summary: "Reprogramar",
                    detail: "Data de entrega não pode ser menor que a data do atendimento.",
                    life: 3000
                });
                return;
            }

            this.lista_exames[this.nova_entrega.index].dt_entrega = this.nova_entrega.dt_entrega;

            if ( !this.lista_exames[this.nova_entrega.index].js_solics ) { 
                this.lista_exames[this.nova_entrega.index].js_solics = {};
            }

            this.lista_exames[this.nova_entrega.index].js_solics.dte = true; 
            this.lista_exames[this.nova_entrega.index].nova_data = true;

            this.$forceUpdate();
            this.fechar_modal('dtEntregaModal');
        },

        toggle_urgencia (atp, index) { 
            this.lista_exames[index].trocar_urgencia = true;
            this.lista_exames[index].fl_urgente = !atp.fl_urgente;
            this.$forceUpdate();
        },

        reprogramar_entrega (atp, index) { 
            this.nova_entrega = _.cloneDeep(atp);
            this.nova_entrega.index = index;

            $('#dtEntregaModal').modal('show');
        },

        fechar_modal(name) { 
            $('#' + name).modal('hide');
        },

        abrir_obs(atp) { 
            this.$refs.obs.abrir('atendimentoProcedimento', atp.id_atendimento_procedimento);
        },
        
        refresh_se_necessario () { 
            //if ( !this.dados.amostras.length ) { 
                this.abrir(this.dados.id_atendimento, true);
                this.$emit('refresh');
            //}
        },

        chamar () { 
            this.rechamado = true;
            this.$emit('chamar', this.dados.marcacao);
        },

        ler_codigo () { 
            let amostra = this.dados.amostras.find(item => item.st_codigo == this.codigo_barra);

            if ( amostra ) { 

                /*
                if ( !this.ident_usuario ) { 
                    alert('oi');
                    return;
                }
                */

                this.$util.atualizar(this, { 
                    service: 'amostras', 
                    func: 'rastreabilidade', 
                    dados: { 
                        codigo: this.codigo_barra, 
                        recebimento: true, 
                        ...( this.ident_usuario ? this.ident_usuario : {} )
                    },
                    callback: res => { 

                        let codigo = this.codigo_barra;

                        this.codigo_barra = "";

                        if ( !res.lista.length ) { 
                            
                            this.$toast.add({
                                severity: "error",
                                summary: "Atenção",
                                detail: 'Amostra não localizada: ' + codigo,
                                life: 3000
                            });

                        } else { 

                            if ( res.lista && res.lista.length > 0 ) { 
                            
                                this.$toast.add({
                                    severity: "success",
                                    summary: "Atenção",
                                    detail: 'Amostra identificada: ' + res.lista.map(amo => amo.st_codigo).join(', '),
                                    life: 3000
                                }); 

                                this.carregar(res.lista[0].id_atendimento);

                            }

                        }

                        if ( res.msg ) { 
                            
                            this.$toast.add({
                                severity: "info",
                                summary: "Atenção",
                                detail: res.msg,
                                life: 5000
                            });

                        }

                    }
                    
                });

                return;

                /*
                if ( amostra.status_amostra == 'R' ) { 
                    this.$toast.add({
                        severity: "info",
                        summary: "Amostra",
                        detail: "Amostra '" + this.codigo_barra + "' já recebida.",
                        life: 3000
                    });
                } else { 
                    amostra.status_amostra = 'R';
                }
                */

            } else { 
                this.$toast.add({
                    severity: "error",
                    summary: "Amostra",
                    detail: "Amostra '" + this.codigo_barra + "' não identificada.",
                    life: 3000
                });
            }

            this.codigo_barra = "";
        },

        cor_exame(item, amostra = null) { 
            if ( item.fl_nova ) { 
                return 'light text-muted text-decoration-line-through';
            }

            if ( item.fl_repeticao && amostra && _.get(amostra, 'rastros.0.status_rastro.st_acao') == 'N' ) { 
                let rastro_item = _.find(amostra.rastros, rastro => { 
                    return rastro.id_atendimento_procedimento == item.id_atendimento_procedimento
                        && rastro.status_rastro 
                        && rastro.status_rastro.st_acao == 'N';
                });
                    
                return rastro_item ? _.get(rastro_item, 'status_rastro.st_color') : 'light';
            }

            return item.fl_repeticao ? 'light' : _.get(item, 'atendimento_procedimento.laudo.status_laudo.st_color', 'light');
        },

        tem_localizacao(amostra) { 
            if ( amostra.status_amostra != 'R' ) { 
                return false;
            }

            let lista = { 
                'C': true,
                'L': true,
            };

            return amostra.rastros.find(item => lista[_.get(item, 'status_rastro.st_id_externo')] || _.get(item, 'status_rastro.st_acao') == 'U')
                ? true : false;
        },

        tem_laudo_pronto(amostra) { 
            return amostra.exames.find(item => _.get(item, 'atendimento_procedimento.laudo.status_laudo.fl_pronto'))
                ? true : false;
        },

        carregar(id_atendimento, id_atendimento_outro = null) { 
            this.$util.load(this, { 
                service: 'atendimentos',
                func: 'show',
                parms: { 
                    id: id_atendimento, 
                    amostras: true, 
                    coleta: this.coleta, 
                    id_atendimento_outro: id_atendimento_outro, 
                },
                loadTo: res => { 
                    if ( this.horabase === null ) { 
                        this.horabase = res.agora;
                    }
                    
                    this.dados = res;
                    this.dados.atendimento_procedimentos = _.orderBy(this.dados.atendimento_procedimentos, 'procedimento.st_procedimento')
                        .filter(item => item.laudo);
                }
            });
        },

        abrir(id_atendimento, reload = false, search = "", id_atendimento_outro = null) { 
            this.dados = null;
            this.pesquisa = search;
            this.rechamado = reload;
            this.apenas_ativas = true; 

            if ( !reload ) { 
                this.horabase = null;
                this.ident_usuario = null;
                this.apenas_curva = false;
            }

            this.carregar(id_atendimento, id_atendimento_outro);

            $('#amostraModal' + this.nome_base).modal('show');
        },

        pre_integrar(func_integrar) { 
            this.atualizar(() => { 
                func_integrar(true);
            });
        },

        atualizar_ident(ident) { 
            this.atualizar(this.callback_ident, ident);
            this.callback_ident = null;
        },

        atualizar(callback = null, ident = null) { 
            if ( this.reident_user ) { 
                if ( this.ident_usuario && !ident ) {
                    ident = this.ident_usuario;
                } else {
                    if ( !ident ) {
                        this.callback_ident = callback;
                        this.$refs.ident_user.abrir(this.atualizar_ident);
                        return;
                    } else { 
                        if ( !ident.login ) { 
                            return;
                        }
                    } 
                } 
            }

            if ( !ident ) { 
                ident = {};
            }

            this.$util.atualizar(this, { 
                service: 'amostras',
                func: 'recebimento',
                dados: { 
                    amostras: this.dados.amostras, 
                    coleta: this.coleta, 
                    em_atendimento: this.em_atendimento, 
                    doc_pre_atends: this.dados.marcacao.doc_pre_atends, 
                    atendimento_procedimentos: this.dados.atendimento_procedimentos, 
                    ...ident, 
                },
                modal: ( this.coleta || callback ) ? '' : 'amostraModal' + this.nome_base, // && this.em_atendimento 
                toast: true,
                callback: res => { 
                    if ( ident && ident.login ) { 
                        this.ident_usuario = ident;

                        let lista = this.$store.state.contexto['ident_logins']
                            ? this.$store.state.contexto['ident_logins'] 
                            : [];

                        lista.push(ident.login);
                        lista = _.uniq(lista).sort();

                        this.$store.commit('setContexto', { ident_logins: lista });
                    }

                    $('.reident_user').modal('hide');

                    if ( callback ) { 
                        callback();
                    }

                    if ( res && res.refresh ) { 
                        this.refresh();
                    }
                }
            });
        },

        refresh () { 
            this.abrir(this.dados.id_atendimento, true);
            this.$emit('refresh');
        },

        // Métodos para o atendimento de coleta.

        iniciarAtendimentoIdent(ident) { 
            this.iniciarAtendimento(ident);
        },

        iniciarAtendimento(ident = null) {
            if ( this.reident_user ) { 
                if ( !ident ) {
                    this.$refs.ident_user.abrir(this.iniciarAtendimentoIdent);
                    return;
                } else { 
                    if ( !ident.login ) { 
                        return;
                    }
                }
            }

            if ( !ident ) { 
                ident = {};
            }

            this.rechamado = true;

            this.$store.commit("loading", true);

            let query = {
                q: [
                    {
                        name: "atendimentos.iniciar",
                        id: "iniciar",
                        parms: { 
                            id: this.dados.id_atendimento,
                            ...ident, 
                            coleta: true, 
                        }
                    }
                ]
            };

            this.axios
                .post("/aql", query)
                .then(res => {
                    if (res.data.iniciar.status == 200) {
                        if (res.data.iniciar.data.id_etapa_atendimento == 6 || res.data.iniciar.data.id_etapa_atendimento == 15) {
                            this.abrir(this.dados.id_atendimento, true);
                            this.$emit('refresh');
                        }

                        if ( ident && ident.login ) { 
                            this.ident_usuario = { ...ident };

                            let lista = this.$store.state.contexto['ident_logins']
                                ? this.$store.state.contexto['ident_logins'] 
                                : [];

                            lista.push(ident.login);
                            lista = _.uniq(lista).sort();

                            this.$store.commit('setContexto', { ident_logins: lista });
                        }

                        $('.reident_user').modal('hide');

                        if ( res.data.iniciar.data.instrucoes && res.data.iniciar.data.instrucoes.length ) { 
                            this.$refs.ciente.abrir(res.data.iniciar.data.instrucoes);
                        }
                    }
                })
                .finally(() => {
                    this.$store.commit("loading", false);
                });
        },

        finalizar(ident = null) {
            if ( this.reident_user ) { 
                if ( this.ident_usuario && !ident ) {
                    ident = this.ident_usuario;
                } else { 
                    // this.$refs.ident_user.abrir(this.finalizar);
                    // return;
                } 
            }

            if ( !ident ) { 
                ident = {};
            }

            this.$store.commit("loading", true);

            let query = {
                q: [
                    {
                        name: "atendimentos.finalizar",
                        id: "finalizar",
                        parms: {
                            id: this.dados.id_atendimento,
                            is_coleta: true, 
                            ...ident, 
                        }
                    }
                ]
            };

            this.axios
                .post("/aql", query)
                .then(res => {
                    if (res.data.finalizar.status == 200) {
                        if ( ident && ident.login ) { 
                            this.ident_usuario = ident;
                        }

                        if (res.data.finalizar.data.id_etapa_atendimento == 7) {
                            this.$toast.add({
                                severity: "success",
                                summary: "Amostra",
                                detail: "Atendimento finalizado.",
                                life: 3000
                            });

                            $('.modal').modal('hide');
                            this.$emit('refresh');
                        }
                    }
                })
                .finally(() => {
                    this.$store.commit("loading", false);
                });
        },

        confirmar_pausa (tempo_pausa) { 

            this.$util.atualizar(this, { 
                service: 'atendimentos',
                func: 'pausar',
                dados: { 
                    id: this.dados.id_atendimento, 
                    dt_timer: tempo_pausa ? moment().add(tempo_pausa, 'minutes').format('YYYY-MM-DD HH:mm') : null,
                },
                callback: () => { 
                    this.$toast.add({
                        severity: "success",
                        summary: "Amostra",
                        detail: "Atendimento pausado.",
                        life: 3000
                    });

                    $('.modal').modal('hide');
                    this.$emit('refresh');
                }
            });

        },

        pausarAtendimento() { 
            this.$refs.pausar.pausar(this.confirmar_pausa, true);

            /*
            if ( !confirm('Confirma pausar o atendimento do paciente?') ) 
                return;
            */

        },

        reabrir () { 

            if ( !confirm ('Confirma reabrir o atendimento (cancelando a finalização realizada)?') )
                return;

            this.$util.atualizar(this, { 
                service: 'pep',
                func: 'reabrir',
                dados: { 
                    id_atendimento: this.dados.id_atendimento,
                },
                callback: () => { 
                    this.refresh();
                }
            });

        },

        

        retomarAtendimento(ident = null) { 
        
            if ( !ident && !confirm('Confirma retomar o atendimento do paciente?') ) 
                return;

            if ( this.reident_user ) { 

                if ( !ident ) {
                    this.$refs.ident_user.abrir(this.retomarAtendimento);
                    return;
                } else { 
                    if ( !ident.login ) { 
                        return;
                    }
                }
            }

            if ( !ident ) { 
                ident = {};
            }

            this.$util.atualizar(this, { 
                service: 'atendimentos',
                func: 'retomar',
                dados: { 
                    id: this.dados.id_atendimento, 
                    ...ident, 
                },
                callback: () => { 
                    $('.reident_user').modal('hide');
                    this.refresh();
                }
            });

        },

        cancelar_atendimento() { 
            if ( !confirm ('Confirma realizar o cancelamento desse atendimento?') )
                return;

            this.$util.remover(this, { 
                service: 'pep',
                dados: { 
                    id_atendimento: this.dados.id_atendimento,
                    coleta: true, 
                },
                callback: () => { 
                    $('.modal').modal('hide');
                    this.$emit('refresh');
                }
            });
        },

    },

    mounted() { 
        this.nome_base = this.uuidv4();

        if ( this.coleta && this.$store.state.user.st_login && this.$store.state.user.st_login.slice(0,6) == 'coleta' ) { 
            this.reident_user = true;
        }
    }

}
</script>

<style scoped>
.text-decoration-line-through {
    text-decoration: line-through !important;
}
</style>